import { makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import { ConfigState } from '@/store/configStore/configState';

const makeConfigService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        getConfig: async () => {
            const res = await fetcher.get(undefined, { disableRedirects: true });
            return (await res.json()) as Promise<Partial<ConfigState>>;
        },
    };
};

export const configService = makeConfigService(config.api.url.config);
